import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./trainerPortal.css";

export default function TrainerWorkExperience() {
  const [companyName, setCompanyName] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [experience, setExperience] = useState("");
  const [roleOptions, setRoleOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await AxiosInstance.get("companies/roles/");
        if (response.status === 200) {
          setRoleOptions(response.data);
        } else {
          setErrorMessage("Failed to fetch roles.");
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
        setErrorMessage("Error fetching roles.");
      }
    };

    fetchRoles();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const trainerId = localStorage.getItem("trainerId");
    if (!trainerId) {
      alert("Trainer not logged in.");
      setIsLoading(false);
      return;
    }

    const newWorkExperience = {
      trainer: trainerId,
      company_name: companyName,
      role: selectedRole,
      experience,
    };

    try {
      const response = await AxiosInstance.post("companies/work-experiences/", newWorkExperience);
      if (response.status === 201) {
        navigate(-1);
      } else {
        setErrorMessage("Failed to add work experience.");
      }
    } catch (error) {
      console.error("Error adding work experience:", error);
      setErrorMessage("Something went wrong.");
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <div
      className="modal d-block als-trainer-portal"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(11,14,39,0.45)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Work Experience</h5>
          </div>

          <div className="modal-body">
            {errorMessage && (
              <div className="alert alert-danger">{errorMessage}</div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Company Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Role</label>
                <select
                  className="form-select"
                  value={selectedRole}
                  onChange={(e) => setSelectedRole(e.target.value)}
                  required
                >
                  <option value="">Select Role</option>
                  {roleOptions.length > 0 ? (
                    roleOptions.map((role) => (
                      <option key={role.role_id} value={role.role_id}>
                        {role.role}
                      </option>
                    ))
                  ) : (
                    <option value="">No roles available</option>
                  )}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Experience</label>
                <input
                  type="text"
                  className="form-control"
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                  required
                />
              </div>

              <div className="modal-footer px-0">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Work Experience
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
